
import React from 'react';

const SuccessPage = props => {
    return (
        <div className="error-page">
          <div className="d-flex align-items-center justify-content-center vh-100">
              <div className="d-flex flex-1 flex-col items-center px-4 py-4 bg-white rounded max-w-sm shadow-lg align-items-center flex-column" >
                    <svg className="w-16 h-16 mt-3 feather feather-check-circle" width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="#1d9d74" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>

                    <h5 className="text-center mt-4">Thank You</h5>
                    <p className="text-center mt-2 text-txt text-lg">Form has been successfully submitted</p>
                    <div className="flex justify-center"></div>
              </div>
          </div>
        </div>
    );
};

export default SuccessPage;